import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { VexModalModule } from 'i2g-ngx-modialog/plugins/vex';
import { SharedModule } from '../shared/shared.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { LoadingDialogComponent } from './components/loading-dialog/loading-dialog.component';
import { PopupBlockedDialogComponent } from './components/popup-blocked-dialog/popup-blocked-dialog.component';
import { DialogComponent } from './dialog.component';
import { DialogService } from './dialog.service';
import { I2gNgUiModule } from 'i2g-ng-ui';
import { FormMasterModule } from '../form-master/form-master.module';
import { CancelSubscriptionFeedbackDialogComponent } from './components/cancel-subscription-feedback-dialog/cancel-subscription-feedback-dialog.component';
import { CancelSubscriptionOfferDialogComponent } from './components/cancel-subscription-offer-dialog/cancel-subscription-offer-dialog.component';
import { TogglePaymentMethodDialogComponent } from '../document-detail/components/toggle-payment-method-dialog/toggle-payment-method-dialog.component';

const components = [
  DialogComponent,
  ConfirmDialogComponent,
  LoadingDialogComponent,
  ErrorDialogComponent,
  PopupBlockedDialogComponent,
  CancelSubscriptionOfferDialogComponent,
  CancelSubscriptionFeedbackDialogComponent,
  TogglePaymentMethodDialogComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    VexModalModule,
    I2gNgUiModule,
    FormMasterModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class DialogModule {
  static forRoot(): ModuleWithProviders<DialogModule> {
    return {
      ngModule: DialogModule,
      providers: [DialogService],
    };
  }
}
